import { apiUrl } from '../config';
import { fetch } from '../utils/http';

export function fetchCoordinationsStart() {
    return {
        type : 'COORDINATIONS_FETCH_START',
    }
}

export function fetchCoordinationsSuccess(data) {
    return {
        type : 'COORDINATIONS_FETCH_SUCCESS',
        data
    }
}

export function fetchCoordinationsFailure(error) {
    return {
        type : 'COORDINATIONS_FETCH_FAILURE',
        error
    }
}

export function fetchCoordinations(page) {
    return function(dispatch) {
        dispatch(fetchCoordinationsStart());
        const url = `${apiUrl()}/coordinations`;
        fetch(url)
            .then(response => response.json())
            .then(json => dispatch(fetchCoordinationsSuccess(json)))
            .catch(error => dispatch(fetchCoordinationsFailure(error)))
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/coordinations.js
 **/